import Vue from 'vue'

export default {
  getDetails () {
    return Vue.http.get('/details')
  },

  bid (price) {
    return Vue.http.patch('/bid', {
      bid_price: price
    })
  }
}
